export default __webpack_public_path__ + "static/media/compare-new.6dea75ab.png";